<template>
  <div>
    <el-popover placement="bottom" width="400" trigger="click">
      <UserMessage :autoRefresh="true" @update="onUpdate" />
      <el-badge  slot="reference" :is-dot="hasMessage"><i class="icon-ring"></i></el-badge>
    </el-popover>
  </div>
</template>

<script>
import api from '@/service/api';
import UserMessage from '@/components/UserMessage';

export default {
  name: 'Ring',
  components: {UserMessage},
  props: {
    menu: Array,
    menuActive: String,
  },  
	data(){
		return {
			isLoading: false,
      currentTab: 'first',
      hasMessage: false,
		}
	},
	created() {
	},
	methods: {
    onUpdate(hasMessage) {
      this.hasMessage = hasMessage;
    }
	}
}	
</script>

<style lang="less" scoped>
</style>